// extracted by mini-css-extract-plugin
export var button = "servicesHeader-module--button--41bea";
export var container = "servicesHeader-module--container--9a278";
export var heading2 = "servicesHeader-module--heading2--5e733";
export var message = "servicesHeader-module--message--d5857";
export var messageTop = "servicesHeader-module--messageTop--ef34b";
export var text = "servicesHeader-module--text--70af5";